<template>
    <div class="home">
        <img class="logo" alt="Quest Me logo" src="../assets/logo.png">
        <div class="groupBouton">
            <Bouton link="/inscription" text="Inscription" white></Bouton>
            <Bouton link="/login" text="J'ai déja un compte"></Bouton>
        </div>
    </div>
</template>

<script>
// @ is an alias to /src
import Bouton from "@/components/boutons/Bouton.vue";

export default {
    name: "home",
    components: {
        Bouton
    }
};
</script>

<style scoped lang="scss">
.home {
    height: 100%;
}
.logo {
    position: relative;
    top: 200px;
    margin: auto;
}
.groupBouton {
    position: fixed;
    width: 100%;
    bottom: 40px;
}
</style>